import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

/**
 * Custom date adapter that parses DD.MM.YYYY input (Ukrainian format).
 * The default NativeDateAdapter cannot reliably parse dot-separated dates
 * when users type them manually.
 */
@Injectable()
export class UaDateAdapter extends NativeDateAdapter {

  override parse(value: string | number): Date | null {
    if (typeof value === 'number') {
      return new Date(value);
    }

    if (!value || typeof value !== 'string') {
      return null;
    }

    const trimmed = value.trim();

    // Try DD.MM.YYYY or D.M.YYYY (dot-separated)
    const dotMatch = trimmed.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
    if (dotMatch) {
      const day = parseInt(dotMatch[1], 10);
      const month = parseInt(dotMatch[2], 10) - 1; // 0-based
      const year = parseInt(dotMatch[3], 10);
      const date = new Date(year, month, day);

      // Validate the date is real (e.g. reject 31.02.2000)
      if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day) {
        return date;
      }
      return null;
    }

    // Fallback to default parsing (handles picker selections, ISO strings, etc.)
    return super.parse(value);
  }
}
